/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_NoteInputs */

const en_cp_mock_note = /** @type {(inputs: Cp_Mock_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note for the team (optional)`)
};

const id_cp_mock_note = /** @type {(inputs: Cp_Mock_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan untuk tim (opsional)`)
};

/**
* | output |
* | --- |
* | "Note for the team (optional)" |
*
* @param {Cp_Mock_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_note = /** @type {((inputs?: Cp_Mock_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_note(inputs)
	return en_cp_mock_note(inputs)
});